<template>
    <div class="modal-container">
        <div class="modal-inner">
            <div class="modal-dialog modal-dialog--small" role="dialog" aria-modal="true">
                <button class="modal-close" @click="$emit('close')">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24">
                        <path d="M256-213.847 213.847-256l224-224-224-224L256-746.153l224 224 224-224L746.153-704l-224 224 224 224L704-213.847l-224-224-224 224Z"/>
                    </svg>
                </button>
                <div class="modal-dialog__content">
                    <div class="search-auto-complete" data-float-labels data-float-labels-class-prefix="form-field">
                        <div class="form-field form-field--floated-label">
                            <input 
                                type="text"
                                v-model="search"
                                @input="onChange"
                                @keydown.down="onArrowDown"
                                @keydown.up="onArrowUp"
                                @keydown.enter="onEnter" 
                                autocomplete="off" 
                            />
                            <label for="search">What are you looking for?</label>
                        </div>
                        <ul id="autocomplete-results" v-show="isOpen" class="search-auto-complete__results">
                            <li class="loading" v-if="isLoading">
                                Loading results...
                            </li>
                            <li v-else v-for="(result, i) in results" :key="i" @click="setResult(result)"
                                class="search-auto-complete__result"
                                :class="{ 'search-auto-complete__result--is-active': i === arrowCounter }">
                                {{ result }}
                            </li>
                        </ul>
                    </div>
                    <div class="d-flex justify-content-end mt-2">
                        <button @click="submitSearch" class="button button--secondary" aria-label="Search site">
                            Search
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const GetHttp = () => import(/* webpackChunkName: 'http' */ '../../_http').then(v=>v.default);
import { floatLabels } from '../../partials/_float-labels';
import { storeToRefs } from 'pinia';
import { useGeneralStore } from '../stores/_general-store';

export default {
    name: 'search-modal',
    setup() {
        const store = useGeneralStore();
        // Extract isLoading as a computed property using storeToRefs
        const { isLoading } = storeToRefs(store);
        return {
            store,
            isLoading,
        };
    },
    data() {
        return {
            isOpen: false,
            results: [],
            search: '',
            arrowCounter: -1,
            items: []
        };
    },
    props: {
        searchUrl: {
            type: String,
            required: false,
            default: '/search'
        },
        rootId: {
            type: Number,
            required: true,
        },
        isAsync: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    watch: {
        items: {
            handler: function (value, oldValue) {
                if (value.length !== oldValue.length) {
                    this.results = value;
                    this.store.updateIsLoading(false);
                }
            },
            deep: true
        }
    },
    methods: {
        setResult(result) {
            this.search = result;
            this.isOpen = false;
        },
        filterResults() {
            this.results = this.items.filter((item) => {
                return item.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
            });
        },
        onChange() {
            this.$emit('input', this.search);

            if (this.isAsync) {
                this.store.updateIsLoading(true);
            } else {
                this.filterResults();
                this.isOpen = true;
            }
        },
        handleClickOutside(event) {
            if (!this.$el.contains(event.target)) {
                this.isOpen = false;
                this.arrowCounter = -1;
            }
        },
        onArrowDown() {
            if (this.arrowCounter < this.results.length) {
                this.arrowCounter = this.arrowCounter + 1;
            }
        },
        onArrowUp() {
            if (this.arrowCounter > 0) {
                this.arrowCounter = this.arrowCounter - 1;
            }
        },
        onEnter() {
            if(this.isOpen) {
                this.search = this.results[this.arrowCounter];
                this.isOpen = false;
                this.arrowCounter = -1;
            }
        },
        async initSearchTerms() {
            this.store.updateIsLoading(false);
              
            this.http = await GetHttp();

            this.http.get('/umbraco/api/search/keysearchterms?root=' + this.rootId).then(({ data }) => {
                console.log(data)
                this.items = data || [];
            });
        },
        submitSearch() {
            let searchString = `?query=${this.search}`;
            window.location.href = this.searchUrl + searchString;
        }
    },
    mounted() {
        this.initSearchTerms();
        document.addEventListener('click', this.handleClickOutside)
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside)
    },
    updated() {
        floatLabels();
    },
};
</script>